import React from 'react';
import { Link } from 'react-router-dom';

function isExternalHref(to) {
  return typeof to === 'string' && /^(https?:|mailto:|tel:)/i.test(to);
}

export default function BrandLogo({
  to = '/mydashboard',
  asLink = true,
  markClassName = 'h-9 w-9 sm:h-10 sm:w-10',
  wordmarkClassName = 'h-5 sm:h-6',
  className = '',
  onClick,
  variant = 'default',
}) {
  const onDark = variant === 'onDark';
  const markSrc = onDark ? '/vitra-mark-on-dark.svg' : '/vitra-mark.svg';
  const wordmarkSrc = onDark ? '/vitra-wordmark-on-dark.svg' : '/vitra-wordmark.svg';

  const content = (
    <>
      <img
        src={markSrc}
        alt=""
        draggable={false}
        className={`${markClassName} flex-shrink-0 object-contain select-none`.trim()}
      />
      <img
        src={wordmarkSrc}
        alt="VITRA"
        draggable={false}
        className={`${wordmarkClassName} w-auto max-w-[7.5rem] sm:max-w-[9rem] object-contain object-left select-none`.trim()}
      />
    </>
  );

  const sharedClass =
    `group inline-flex items-center gap-1.5 outline-none rounded-md focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 ${className}`.trim();

  if (asLink) {
    if (isExternalHref(to)) {
      return (
        <a href={to} className={sharedClass} aria-label="VITRA home" onClick={onClick}>
          {content}
        </a>
      );
    }
    return (
      <Link to={to} className={sharedClass} aria-label="VITRA home" onClick={onClick}>
        {content}
      </Link>
    );
  }

  if (typeof onClick === 'function') {
    return (
      <button type="button" className={sharedClass} aria-label="VITRA home" onClick={onClick}>
        {content}
      </button>
    );
  }

  return (
    <div className={sharedClass} aria-label="VITRA">
      {content}
    </div>
  );
}
